// src/components/hints/HintSystem.js
import React from 'react';
import useStore from '../../store';
import { useTranslation } from 'react-i18next';
import { HINTS_DATA } from './HintsRegistry';
import './HintSystem.css';

const HintSystem = () => {
  const { t } = useTranslation();
  const activeHintId = useStore(state => state.activeHintId);
  const store = useStore.getState();
  const { menu } = store.ref;

  // Получаем текущую тему из мафии
  const activeTheme = menu.activeTheme || 'cardcolor';

  if (!activeHintId || !HINTS_DATA[activeHintId]) return null;

  const config = HINTS_DATA[activeHintId];
  const isMini = config.className === 'hint-mini-tooltip';

  const handleClose = (fromOverlay = false) => {
    const hasButton = !!config.buttonKey;
    const shouldMark = fromOverlay ? (config.markAsReadOnOverlayClick || !hasButton) : true;
    menu.methods.closeHint(activeHintId, shouldMark);
  };

  // Комбинируем классы: базовый для тем + текущая тема + специфичный для подсказки
  const cardClassName = `mafia-generic-card theme-${activeTheme} hint-card ${config.className || ''}`;

  return (
    <div
      className="hint-overlay"
      style={{ backgroundColor: `rgba(0, 0, 0, ${config.opacity ?? 0.5})` }}
      onClick={(e) => e.target === e.currentTarget && handleClose(true)}
    >
      <div
        className={cardClassName}
        style={config.style || {}} // style из реестра перекроет CSS (inline style has priority)
        onClick={e => e.stopPropagation()}
      >
        {/* Используем системные классы mpc-header и mpc-title для совместимости с темами */}
        {!isMini && config.titleKey && (
          <div className="mpc-header hint-header-fix">
            <h3 className="mpc-title">{t(config.titleKey)}</h3>
          </div>
        )}

        <div className="hint-body">
          {config.imageKey && (
            <img
              src={t(config.imageKey)}
              alt="Hint"
              className="hint-card-img"
              onLoad={() => menu.methods.render()}
            />
          )}
          <div className="hint-card-text">{t(config.textKey)}</div>
        </div>

        {!isMini && config.buttonKey && (
          /* Кнопка теперь автоматически красится темой проекта */
          <button className="mpc-button" onClick={() => handleClose(false)}>
            {t(config.buttonKey)}
          </button>
        )}
      </div>
    </div>
  );
};

export default HintSystem;